import React, { PropsWithChildren } from 'react';
import { SnackbarProvider as NotistackProvider } from 'notistack';

function SnackbarProvider({ children }: PropsWithChildren) {
  return (
    <NotistackProvider anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }} preventDuplicate>
      {children}
    </NotistackProvider>
  );
}

export default SnackbarProvider;
